import { createFileRoute } from '@tanstack/react-router';
import ImportDetailView from '../bulk-import/imports/detail/import-detail-view';
export const Route = createFileRoute('/bulk-import/imports/$importGuid')({
  component: ImportDetailView,
});
